import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import ProgramLevelsActions, { ProgramLevelsRedux, ProgramLevelsTypes } from '../Redux/ProgramLevelsRedux'

const ProgramLevelsCRUDObservable = createCRUDObservable({
  mainRedux: ProgramLevelsRedux,
  reduxPath: 'programLevels',
})

export const ProgramLevelsObservers = Object.assign({}, ProgramLevelsCRUDObservable.observers, {})


export const ProgramLevelsEpic = combineEpics(
  ProgramLevelsCRUDObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ProgramLevelsObservable.js